<template>
    <InvoiceDetails/>
</template>
<script>
import InvoiceDetails from '../../components/invoices/InvoiceDetails';

export default {
  components: {
    InvoiceDetails,
  },
};
</script>
